import StorageHelper from "../helpers/StorageHelper";
import { history } from "./index";

class SessionService {
  constructor() {
    this.storageHelper = new StorageHelper();
  }

  getUsuario() {
    const dadosSession = this.storageHelper.getLocal("dados");
    const dados = JSON.parse(dadosSession);
    return dados.usuario;
  }

  getEmpresa() {
    const dadosSession = this.storageHelper.getLocal("dados");
    const dados = JSON.parse(dadosSession);
    return dados.empresa;
  }

  getEmpresaRelatorio() {
    const dadosSession = this.storageHelper.getLocal("dados");
    const dados = JSON.parse(dadosSession);
    const empresa = dados.empresa;
    return {
      imagemLogo: empresa.imagemLogo,
      fantasia: empresa.fantasia,
      cnpjCpf: empresa.cnpjCpf,
      enderecoLogradouro: empresa.enderecoLogradouro,
      enderecoLogradouroNumero: empresa.enderecoLogradouroNumero,
      enderecoBairro: empresa.enderecoBairro,
      enderecoCidade: empresa.enderecoCidade,
      enderecoUF: empresa.enderecoUF,
    };
  }

  setEmpresa(empresa) {
    const dadosSession = this.storageHelper.getLocal("dados");
    const dados = JSON.parse(dadosSession);
    dados.empresa = empresa;
    this.storageHelper.setLocal("dados", JSON.stringify(dados));
  }

  setConfiguracoesEmpresa(configuracoesData) {
    const configuracoes = {
      diasVencimentoOrcamento: configuracoesData.diasVencimentoOrcamento,
      limiteCredito: configuracoesData.limiteCredito,
      inadimplencia: configuracoesData.inadimplencia,
      operacaoFiscalPdvPadraoId: configuracoesData.operacaoFiscalPdvPadraoId,
      operacaoFiscalPdvSecundariaId:
        configuracoesData.operacaoFiscalPdvSecundariaId,
      operacaoFiscalVendasPadraoId:
        configuracoesData.operacaoFiscalVendasPadraoId,
      operacaoFiscalMdfePadraoId: configuracoesData.operacaoFiscalMdfePadraoId,
      operacaoFiscalComprasPadraoId:
        configuracoesData.operacaoFiscalComprasPadraoId,
      cfopComprasPadraoId: configuracoesData.cfopComprasPadraoId,
      precificacaoNfEntrada: configuracoesData.precificacaoNfEntrada,
      margemCalculo: configuracoesData.margemCalculo,
      visualizarImpressaoEmissao: configuracoesData.visualizarImpressaoEmissao,
      obrigatoriedadeMeioPagamento:
        configuracoesData.obrigatoriedadeMeioPagamento,
      lembreteAntecedenciaServico:
        configuracoesData.lembreteAntecedenciaServico,
      descontoVendaItem: configuracoesData.descontoVendaItem,
      despesaVendaItem: configuracoesData.despesaVendaItem,
      freteVendaItem: configuracoesData.freteVendaItem,
      zerarSaldoAnteriorCaixa: configuracoesData.zerarSaldoAnteriorCaixa,
      utilizarSuprimentoSangria: configuracoesData.utilizarSuprimentoSangria,
      exibirDescricaoServico: configuracoesData.exibirDescricaoServico,
      buscaProdutosCodigoBarras: configuracoesData.buscaProdutosCodigoBarras,
      inicialCodigoBarrasBalanca: configuracoesData.inicialCodigoBarrasBalanca,
      leituraPadraoBalanca: configuracoesData.leituraPadraoBalanca,
      vendaEstoqueNegativo: configuracoesData.vendaEstoqueNegativo,
      impressoraEtiqueta: configuracoesData.impressoraEtiqueta,
      impressoraTermica: configuracoesData.impressoraTermica,
      impressaoDiretaNf: configuracoesData.impressaoDiretaNf,
      impressaoDiretaOrcamentos: configuracoesData.impressaoDiretaOrcamentos,
      impressaoDiretaPedidos: configuracoesData.impressaoDiretaPedidos,
      confirmacaoImpressaoNf: configuracoesData.confirmacaoImpressaoNf,
      modalidadeComissao: configuracoesData.modalidadeComissao,
      confirmacaoImpressaoOrcamentos:
        configuracoesData.confirmacaoImpressaoOrcamentos,
      confirmacaoImpressaoPedidos:
        configuracoesData.confirmacaoImpressaoPedidos,
      vendedorPorItemServico: configuracoesData.vendedorPorItemServico,
      meioPagamentosPadroesConfiguracoes:
        configuracoesData.meioPagamentosPadroesConfiguracoes.map(
          (meioPagamentoConfiguracao) => {
            return {
              id: meioPagamentoConfiguracao.id,
              config: meioPagamentoConfiguracao.configuracaoId,
              meioPa: meioPagamentoConfiguracao.meioPagamentoId,
              pct_co: meioPagamentoConfiguracao.pct_configuracao_id,
            };
          },
        ),
    };
    const dadosSession = this.storageHelper.getLocal("dados");
    const dados = JSON.parse(dadosSession);
    dados.empresa.configuracoes = configuracoes;
    this.storageHelper.setLocal("dados", JSON.stringify(dados));
  }

  getEmpresaAndUsuario() {
    const dadosSession = this.storageHelper.getLocal("dados");
    return JSON.parse(dadosSession);
  }

  getPermisoes() {
    const dadosSession = this.storageHelper.getLocal("dados");
    if (dadosSession) {
      const dados = JSON.parse(dadosSession);
      return dados.usuario.perfilUsuario.permisoes;
    }
    return [];
  }

  setToken(token) {
    this.storageHelper.setLocal("token", token);
  }

  setSession(data) {
    this.storageHelper.setLocal("token", data.token);
    this.storageHelper.setLocal("dados", JSON.stringify(data.dados));
  }

  deslogar() {
    this.storageHelper.removeLocal("token");
    this.storageHelper.removeLocal("rotinas");
    this.storageHelper.removeLocal("theme");
    this.storageHelper.removeLocal("dados");
    this.storageHelper.removeSession("notificacao");
    history.push("/login");
  }
}

export default SessionService;
